const columns= [
    {
        title: 'Update Date',
        dataIndex: 'createdDate',      
    },
    {
        title: 'Audit LogType',
        dataIndex: 'auditLogType',      
    },
    {
        title: 'Old Values',
        dataIndex: 'oldValues',
    },
    {
        title: 'New Values',
        dataIndex: 'newValues',
    },   
   
];

export default columns;